
//calculate the scroll offset top - used to make the page content show below the header + side menu on smaller screens
const calculateScrollMarginTop = () => {
    window.setTimeout(() => {

        //
        const root = document.querySelector(':root');

        //only do this while the viewport is considered "small"
        if (window.innerWidth > parseInt(getComputedStyle(root).getPropertyValue('--small-viewport-width'), 10)) {
            return;
        }

        //
        const offset = document.querySelector('.site-header').clientHeight + document.querySelector('.site-sidebar-wrapper').clientHeight;
        root.style.setProperty('--scroll-margin-top', `${offset}px`);

    }, 10);
};

//
window.addEventListener('resize', calculateScrollMarginTop);
calculateScrollMarginTop();
